import FieldDefs from './AiConcurentsFieldDefs'
import {doLangFields} from '../../lib/ks-tools'
import {Listeners} from "../../constants/listeners";
import ReportApi from "../../api/ReportApi";

export default {
    template: `<div><slot v-bind="self" /></div>`,
    data () {
        return {
            fields: doLangFields(this, "lang.report.aiconcurents.fields", FieldDefs),
            sortOrder: [
                {
                    field: 'cnt',
                    direction: 'desc'
                }
            ],
            moreParams: {},
            aiCompState: Number(this.initialAiCompState ?? 0),
            pollingInterval: null,
        }
    },
    props: {
        initialAiCompState: {
            type: Number,
            default: 0
        },
        domain: {
            type: String,
            required: true
        },
        db: {
            type: String,
            required: true
        },
    },
    mounted () {
        this.initFields();
        if (!this.isYandexMsk) {
            this.stopPolling();
            return;
        }
        // Делаем первый запрос статуса сразу после монтирования
        this.checkAiCompState();
        // Запускаем polling если статус CREATED (0) или STARTED (1)
        if (this.aiCompState === 0 || this.aiCompState === 1) {
            this.startPolling();
        }
        // Обновляем индикатор статуса в bodyTitle после монтирования DOM
        this.$nextTick(() => {
            this.updateStatusIndicator();
        });
    },
    beforeUnmount() {
        this.stopPolling();
    },
    watch: {
        aiCompState(newState) {
            if (newState === 0 || newState === 1) {
                this.startPolling();
            } else {
                this.stopPolling();
            }
            this.updateStatusIndicator();
        },
    },
    computed: {
        self() {
            return this;
        },
        isYandexMsk() {
            return this.db === 'msk';
        },
        onlyMskText() {
            return this.$t('lang.report.aiconcurents.only_msk_notice');
        },
        getApiUrl() {
            return '/report/simple/organic/ai-concurents?base=' + this.db + '&domain=' + this.domain;
        }
    },
    methods: {
        getStateKey() {
            const keys = {
                0: 'created',
                1: 'building',
                2: 'error',
                10: 'ready'
            };
            return keys[this.aiCompState] || 'created';
        },
        startPolling() {
            this.stopPolling();
            this.pollingInterval = setInterval(() => {
                this.checkAiCompState();
            }, 3000);
        },
        stopPolling() {
            if (this.pollingInterval) {
                clearInterval(this.pollingInterval);
                this.pollingInterval = null;
            }
        },
        async checkAiCompState() {
            try {
                const data = await ReportApi.getAiCompState({
                    domain: this.domain,
                    base: this.db
                });
                const newState = data.state || 0;
                if (newState !== this.aiCompState) {
                    this.aiCompState = newState;
                    if (newState === 10 || newState === 2) {
                        this.stopPolling();
                        if (newState === 10) {
                            this.$emitter.emit(Listeners.KS_TABLE_DO_LOAD);
                        }
                    }
                }
            } catch (error) {
                console.error('Ошибка при проверке статуса ИИ-конкурентов:', error);
            }
        },
        updateStatusIndicator() {
            const icon = document.getElementById('ai-concurents-status-icon');
            if (!icon) {
                return;
            }
            if (this.aiCompState !== 10) {
                const icons = {
                    0: 'pi pi-sync text-color-secondary text-sm',
                    1: 'pi pi-spin pi-sync text-color-secondary text-sm',
                    2: 'pi pi-exclamation-triangle text-red-500 text-sm',
                };
                icon.style.display = 'inline-block';
                icon.className = icons[this.aiCompState] || icons[0];
                icon.removeAttribute('title');
                icon.removeAttribute('data-original-title');
            } else {
                icon.style.display = 'none';
            }
        },
        initFields () {
            let self = this;
            self.fields.forEach((f) =>{
                if(f.hasOwnProperty('visibleRule')){
                    f.visible = eval(f.visibleRule);
                }
            });
            this.$emitter.emit(Listeners.KS_TABLE_NORMALIZE_FIELDS);
        },
    },
}

